export default __webpack_public_path__ + "static/media/organic-certification.095cb307.svg";